import React from 'react'
import styled from 'styled-components';

const ContainerTitle = styled.div<{ className: string }>`
    margin-top: 30px;
    margin-bottom: 30px;
    padding-left: 6px;
    padding-right: 6px;

    > div{
        width: fit-content;
        position: relative;
        padding-bottom: 8px;
    }

    > div h2, h4{
        margin: 0;
        text-transform: uppercase;
    }

    > h4{
        font-style: italic;
        font-weight: 500;
        color: ${p => p.theme.palette.text.gray};
        margin-bottom: 2px;
    }

    > div h2{
        color: ${p => p.theme.palette.text.primary};
    }

    ${p => p.className || ''}
`
const TitleBar = styled.div`
    width: 30px;
    height: 7px;
    background: ${p => p.theme.palette.secondary.main};
    position: absolute;
    right: 0;
    bottom: 0;
    border-radius: 6px 0 15px 6px;
    transform: skew(-30deg)
`

interface IOwnProps{
    preTitle: string;
    title: string;
    className?: string;
}

const TitleSection: React.FunctionComponent<IOwnProps> = ({ preTitle, title, className = '' }) => {
  return (
    <ContainerTitle className={className}>
        <h4>{preTitle}</h4>
        <div>
            <h2>{title}</h2>
            <TitleBar />
        </div>
    </ContainerTitle>
  )
}

export default TitleSection